import { useEffect } from "react";
import { NotificationManager } from "../../../notifications/NotificationManager";
import { useApp } from "../../../context/AppContextProvider";
import { useAuth } from "../../../context/UserContextProvider";
import i18n from "../../../language/i18n";
import ErrorLayout from "../../../components/common/error/ErrorLayout";

const NetworkErrorScreen = () => {
  const { setBoarding, isFullScreen, setIsFullScreen } = useApp();
  const { handleStateLogout } = useAuth();

  useEffect(() => {
    if (isFullScreen === false) {
      setIsFullScreen(true);
    }
  }, []);

  const handleClickToNavigate = () => {
    handleStateLogout();
    setBoarding("LANDING");
    NotificationManager.success(i18n.t("logout_successful_text"));
  };

  return (
    <ErrorLayout
      statusText={i18n.t("network_error_status_text")}
      helpText={i18n.t("network_error_help_text")}
      tone="warning"
      icon="signal"
      actionTitle={i18n.t("login")}
      onAction={handleClickToNavigate}
    />
  );
};

export default NetworkErrorScreen;
